
import { Component, Prop } from 'vue-property-decorator'
import Mixin from '../helpers/mixin'
import { IDownload } from '../store/modules/request-download'

@Component({
  template: `
    <div v-if='downloadForm' @click='downloadFile(hrefLocation, downloadForm)' class="contact-anchor__button download-cataloge flex">
      <i aria-hidden="true" class="icons8-page"></i>
      <transition>
        <div class="contact-anchor__button-text">
          {{ title }}
          <i aria-hidden="true" class="icons8-chevron-down-2"></i>
        </div>
      </transition>
    </div>

    <a v-else :href="hrefLocation" target='_blank' download class="contact-anchor__button download-cataloge flex">
      <i aria-hidden="true" class="icons8-page"></i>
      <transition>
        <div class="contact-anchor__button-text">
          {{ title }}
          <i aria-hidden="true" class="icons8-chevron-down-2"></i>
        </div>
      </transition>
    </a>
  `
})
export default class DownloadCatalogButton extends Mixin {
  @Prop({ default: '' }) title: string
  @Prop({ default: '' }) hrefLocation: string
  @Prop({ default: '' }) downloadForm: boolean

  offsetButton = '0px'

  placeButton(): void {
    const downloadCatalogElement = document.querySelector('.download-cataloge')
    const stickyElement = document.querySelector('.contact-anchor__wrap')

    if (downloadCatalogElement) {
      downloadCatalogElement?.remove()
      if (stickyElement) {
        this.offsetButton = stickyElement.firstElementChild ? (stickyElement.firstElementChild.clientHeight + 1) + 'px' : '0px'
        stickyElement.appendChild(downloadCatalogElement)
      }
    }
  }

  downloadFile(download: IDownload, form: any): void {
    this.$store.commit('requestDownload/open', {download, form})
  }

  mounted(): void {
    this.$nextTick(() => this.placeButton())
  }
}
